import React, { useState, useEffect } from "react";
import ChartSidebarAccordion from "../ChartSidebarAccordion";
import { useSelector } from "react-redux";
import userActions from "../actions";
import ColoradoRiverAccessLocationFilter from "../ColoradoRiverAccessLocationFilter";
import { Typography, Grid } from "@material-ui/core";
import useStyles from "../Styles";
import technicalActions from '../../TechnicalView/actions';
import { useHistory } from "react-router";
import { YEAR_LIST } from "../constants";
import CustomSidebarAccordion from "../CustomSidebarAccordion";

function PriorityMetrics({ metrics }) {
  const classes = useStyles();
  return (
    <Grid
      container
      direction="row"
      spacing={1}
      className={classes.metricsContainer}
    >
      {metrics.map((metric, idx) => (
        <React.Fragment key={`${metric.value}_${idx}`}>
          <Grid item align="right" sm={4}>
            <Typography
              variant="body2"
              component="p"
              className={classes.gaugeMetricTitle}
              display="inline"
            >
              {metric.year}
            </Typography>
          </Grid>
          <Grid item align="right" sm={8} style={{ paddingRight: "20px" }}>
            <Typography
              variant="h6"
              component="div"
              className={classes.gaugeMetricValue}
              display="inline"
            >
              {metric.value}
            </Typography>
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
}

function AreaChartTabAccordions({ metrics }) {
  const accordion_names_map = {
    "dummy": "dummy",
    "NIA": "nia",
    "Indian": "indian",
    "M&I": "m&i",
    "P2, P3 & PWM" :"p13",
    "DCP NIA": "dcp_nia",
    "Leases & Exchanges": "leases_exchanges",
  }
  const [expandedAccordion, setExpandedAccordion] = useState(null); 

  const handleAccordionChange = (accordionName) => {
    setExpandedAccordion((prev) => (prev === accordionName ? null : accordionName));
  };

  return (
    <>
      {metrics.map((item, idx) => (
        <CustomSidebarAccordion
          key={item?.label}
          group_name={item.label}
          accordion_name={accordion_names_map[item.label]}
          expanded={expandedAccordion === accordion_names_map[item.label]} 
          onChange={handleAccordionChange} 
          hidden={false}
        >
          <PriorityMetrics metrics={item.values} />
        </CustomSidebarAccordion>
      ))}
    </>
  );
}

function AreaChartTabWesternAccordions({ metrics }) {
  const [expandedAccordion, setExpandedAccordion] = useState(null); 

  const handleAccordionChange = (accordionName) => {
    setExpandedAccordion((prev) => (prev === accordionName ? null : accordionName));
  };
  
  return (
    <>
      {metrics.map((item, idx) => (
        <CustomSidebarAccordion 
          key={item?.label} 
          group_name={item.label} 
          accordion_name={item.label} 
          hidden={false}
          expanded={expandedAccordion === item.label}
          onChange={handleAccordionChange}
        >
          <PriorityMetrics metrics={item.values} />
        </CustomSidebarAccordion>
      ))}
    </>
  );
}

function AreaChartChartTab() {
  const classes = useStyles();
  const { priority_entitlements, entity_entitlements, area_chart_tab, cities, city_selected, scenario_selected, is_western, western_arizona_selected, western_arizona_entities, western_entity_entitlements, irrigation_districts } =
    useSelector((state) => state.technical_view);

  const {
      setSelectedCity,
      loadEntityEntitlements,
      loadWesternArizonaEntityEntitlements,
      setIsTribe,
      setIsCity,
      setIsWesternEntity,
      setSelectedWesternArizonaEntity,
      setSelectedIrrigationDistrict,
    } = userActions();
  // const year_list = ["2024", "2025", "2026", "2027", "2028"];

  const cityWestern = cities
    .concat(western_arizona_entities);

  const priority_names_map = {
    nia_priority_contract_entitlement: "NIA",
    indian_priority_contract_entitlement: "Indian",
    mi_priority_contract_entitlement: "M&I",
    p13_contract_entitlement: "P2, P3 & PWM",
    dcp_nia_contract_entitlement: "DCP NIA",
    leases_exchanges: "Leases & Exchanges",
  };

  let dummy_metrics = [
    {
      label: "Priority",
      values: [
        {
          year: "year",
          value: `XXXX ac-ft available`,
        },
      ],
    },
  ];
  const [metrics_state_tab, setMetricsStateTab] = useState(dummy_metrics);
  const [metrics_entity_tab, setMetricsEntityTab] = useState(dummy_metrics);
  const [metrics_western_entity_tab, setMetricsWesternEntityTab] = useState(dummy_metrics);

  const priorityEntitlementFunction = () => {
    if (Object.keys(priority_entitlements).length > 0) {
      let metrics = [];
      Object.keys(priority_names_map).map((priority) => {
        let root_key, value;
        let values = [];
        YEAR_LIST.map((year) => {
          if (priority_entitlements[year] !== undefined) {
            root_key = Object.keys(priority_entitlements[year])[0];

            if (priority in priority_entitlements[year][root_key]) {
              let amount = priority_entitlements[year][root_key][priority];
              value = {
                year: year,
                value: `${Math.round(amount).toLocaleString(
                  "en-US"
                )} ac-ft available`,
              };
              values.push(value);
            }
          }
          return year
        });
        if (priority !== "leases_exchanges") {
          metrics.push({
            label: priority_names_map[priority],
            values: values,
          });
        }
        return priority       
      });
      setMetricsStateTab(metrics);
    }
  }
  useEffect(priorityEntitlementFunction, [priority_entitlements]);

  const entityEntitlementsHook = () => {
    if (Object.keys(entity_entitlements).length > 0) {
      let metrics = [];

      Object.keys(priority_names_map).map((priority) => {
        let root_key, value;
        let values = [];
        YEAR_LIST.map((year) => {
          if (
            entity_entitlements[year] !== undefined &&
            "indivisual_priority_entitlements" in entity_entitlements[year]
          ) {
            root_key = "indivisual_priority_entitlements";
            if (priority in entity_entitlements[year][root_key]) {
              let amount = entity_entitlements[year][root_key][priority];
              value = {
                year: year,
                value: `${Math.round(amount).toLocaleString(
                  "en-US"
                )} ac-ft available`,
              };
              values.push(value);
            }
          }
          return year
        });
        metrics.push({
          label: priority_names_map[priority],
          values: values,
        });
        return priority
      });
      setMetricsEntityTab(metrics);
    }
  }
  useEffect(entityEntitlementsHook, [entity_entitlements]);


  const westernEntitlementsHook = () => {
    if (Object.keys(western_entity_entitlements).length > 0) {
      let metrics = [];

      Object.keys(western_entity_entitlements[YEAR_LIST[0]]["priorities"]).map((priority) => {
        let root_key, value;
        let values = [];
        YEAR_LIST.map((year) => {
          if (
            western_entity_entitlements[year] !== undefined &&
            "priorities" in western_entity_entitlements[year]
          ) {
            root_key = "priorities";
            if (priority in western_entity_entitlements[year][root_key]) {
              let amount = western_entity_entitlements[year][root_key][priority]; 
              value = {
                year: year,
                value: `${Math.round(amount).toLocaleString(
                  "en-US"
                )} ac-ft available`,
              };
              values.push(value);
            }
          }
          return year
        });
        metrics.push({
          label: priority,
          values: values,
        });
        return priority
      });
      setMetricsWesternEntityTab(metrics);
    }
  }

  useEffect(westernEntitlementsHook, [western_entity_entitlements]);
  const {setUserLastSelectedMapState} = technicalActions();
  const history = useHistory()
  const handleChange = (value) => {
    // const city = cities.filter((item) => item.value == value)[0];
    // if location is changed reset the user last selected map state
    setUserLastSelectedMapState({
      center: null,
      zoom: null,
    });
    var entityFound = cityWestern.find((entity) => entity.value === value);
    // var cityFound = cities.find((item) => item.value == (value));
    // setSelectedCity(cityFound);      // city_selected is used on AboutTab
    // loadEntityEntitlements(value, scenario_selected.value);
    // setIsTribe(false);
    // setIsWesternEntity(false);
    if (entityFound.entity_type === "Central") {
      setSelectedCity(entityFound);
      setIsCity(true);
      setIsTribe(false);
      setIsWesternEntity(false);
      loadEntityEntitlements(value, scenario_selected.value);

      /** If the entity found is of type 'Central' then push them to 'cities' route path */
      history.push({
        pathname: `/visualizations/area`,
        search:  "?" + new URLSearchParams({type: "cities", dropdown: entityFound?.label}).toString()
      });
    } else {
      setSelectedWesternArizonaEntity(entityFound);

      const checkIrrigationDistrict = irrigation_districts?.find((item) => item?.label === entityFound?.label)
      if(checkIrrigationDistrict) {
        setSelectedIrrigationDistrict(checkIrrigationDistrict); 
      }
      setIsWesternEntity(true);
      setIsCity(false);
      setIsTribe(false);
      loadWesternArizonaEntityEntitlements(value, scenario_selected.value);

      /** If the entity found is of not of type 'Central' then push them to 'western' route path */
      history.push({
        pathname: `/visualizations/area`,
        search:  "?" + new URLSearchParams({type: "irrigation_district", dropdown: entityFound?.label}).toString()
      });
    }
  };
  return (
    <>
      <ColoradoRiverAccessLocationFilter
        location_options={cityWestern}
        handleChange={handleChange}
        city_id={is_western? western_arizona_selected.entity_id :city_selected.city_id}
        style={{ marginLeft: 26 }}
        autocomplete={true}
        show={area_chart_tab.value === 2 ? true : false}
      />
      <Typography
        variant="body2"
        component="div"
        className={classes.metricSubTitle} 
      >
        
      </Typography>
      {
        area_chart_tab.label === "State"?(
          <AreaChartTabAccordions
            metrics={metrics_state_tab}
          />
        ): !is_western? (
          <AreaChartTabAccordions
            metrics={metrics_entity_tab}
          />
        ): Object.keys(western_entity_entitlements).length !== 0?(
          <AreaChartTabWesternAccordions
            metrics={metrics_western_entity_tab}
          />
        ):(
          <Typography
            variant="body2"
            component="div"
            className={classes.metricSubTitle}
          >
            The {western_arizona_selected.name} does not have an entitlement to Colorado River water but may receive Colorado River water from partners who deliver it to the irrigation district’s groundwater savings facility
          </Typography>
        )
      }
      
    </>
    
  );
}
export default AreaChartChartTab;
